import HoldingSettlementPage from './HoldingSettlementPage';
import SettlementQueueList from '../../components/HoldingSettlement/SettlementQueueList';

const SettlementQueue = () => (
    <HoldingSettlementPage
        title="Settlement Queue"
        breadcrumbTitle="Settlement Queue"
    >
        <SettlementQueueList />
    </HoldingSettlementPage>
);

export default SettlementQueue;
